/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;
//window.axios = require('axios');

Vue.prototype.$http = require('axios');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import vmodal from 'vue-js-modal'

Vue.use(vmodal);
Vue.component('vbutton', require('./components/common/Button.vue').default);
Vue.component('client-invoices', require('./components/ClientInvoices.vue').default);
Vue.component('ip-domains', require('./components/IpDomains.vue').default);
Vue.component('due-invoices', require('./components/DueInvoices.vue').default);
Vue.component('select-invoice-order', require('./components/SelectOrderInvoice.vue').default);
Vue.component('order-invoices', require('./components/OrderInvoices.vue').default);
Vue.component('invoice-drafts-new', require('./components/drafts/InvoiceDraftsNew').default)
Vue.component('google-task-ads', require('./components/GoogleAdsTasks.vue').default);
Vue.component('invoice-modal', require('./components/InvoiceModal.vue').default);
Vue.component('payment-modal', require('./components/PaymentModal.vue').default);
Vue.component('invoices', require('./components/Invoices.vue').default);
Vue.component('invoice-drafts', require('./components/InvoiceDrafts.vue').default);
// Vue.component('order-customizations', require('./components/OrderCustomizations.vue').default);
Vue.component('model-events', require('./components/ModelEvents.vue').default);
Vue.component('order-notes', require('./components/OrderNotes.vue').default);
Vue.component('pager', require('./components/Pager.vue').default);
Vue.component('edit-domain', require('./components/EditDomain.vue').default);
Vue.component('gads-statuses', require('./components/GoogleTaskAdsWidget').default);
Vue.component('orders-with-google-ads-campaign-status', require('./components/OrdersWithGoogleAdsTasksStatuses').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#vueApp',
});
